import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PlantillaDetalle = ({
  tabs = [], 
  activeTab, 
  onTabChange, 
  children
}) => {
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  // Función para verificar si hay scroll disponible
  const checkScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 5);
    }
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, [tabs]);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 200;
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="bg-[#f4f7fa] min-h-screen pb-10">
      <div className="max-w-7xl mx-auto px-4 mt-4">
        
        {/* CONTENEDOR DE PESTAÑAS */}
        <div className="relative mb-0 group">
          
          {/* Botón Izquierdo */}
          {showLeftArrow && (
            <button 
              onClick={() => scroll('left')}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-30 bg-white shadow-lg border border-gray-200 p-1.5 rounded-full text-blue-600 hover:bg-gray-50 transition-all"
            >
              <ChevronLeft size={20} />
            </button>
          )}

          {/* Área de Scroll */}
          <div 
            ref={scrollContainerRef}
            onScroll={checkScroll}
            className="flex overflow-x-auto scrollbar-hide p-2 bg-gray-200/40 rounded-t-[2rem] border-x border-t border-gray-200/50"
          >
            <nav className="flex space-x-2">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;
                const showBadge = tab.count !== undefined && tab.count !== null && Number(tab.count) > 0;
                
                return (
                  <button
                    key={tab.id}
                    onClick={() => onTabChange(tab.id)}
                    className={`
                      relative flex items-center justify-center py-4 px-8 min-w-[160px] flex-shrink-0
                      font-bold text-sm transition-all duration-300 rounded-2xl
                      ${isActive 
                        ? 'bg-white text-blue-600 shadow-md transform -translate-y-1' 
                        : 'text-gray-500 hover:text-gray-700 hover:bg-white/50'}
                    `}
                  >
                    {isActive && (
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-12 h-1.5 bg-blue-600 rounded-b-xl shadow-[0_2px_8px_rgba(37,99,235,0.4)]" />
                    )}

                    {showBadge && (
                      <span className="absolute top-2.5 right-4 flex h-5 min-w-[20px] px-1.5 items-center justify-center rounded-full bg-red-500 text-[10px] font-black text-white shadow-sm ring-2 ring-white z-20">
                        {tab.count}
                      </span>
                    )}

                    <div className="flex items-center gap-3">
                      {Icon && (
                        <div className={`p-1.5 rounded-lg transition-colors ${isActive ? 'bg-blue-50' : 'bg-gray-100'}`}>
                          <Icon size={18} className={isActive ? 'text-blue-600' : 'text-gray-400'} />
                        </div>
                      )}
                      <span className="whitespace-nowrap uppercase tracking-wide text-[11px]">
                        {tab.label}
                      </span>
                    </div>
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Botón Derecho */}
          {showRightArrow && (
            <button 
              onClick={() => scroll('right')}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-30 bg-white shadow-lg border border-gray-200 p-1.5 rounded-full text-blue-600 hover:bg-gray-50 transition-all"
            >
              <ChevronRight size={20} />
            </button>
          )}
        </div>

        {/* CUERPO DE LA CARD (No lo quites, es lo que da el fondo blanco) */}
        <main className="bg-white border border-gray-200 shadow-xl rounded-b-[2rem] rounded-tr-[2rem] p-6 md:p-10 relative z-0 -mt-[1px]">
          <div className="animate-in fade-in slide-in-from-bottom-2 duration-700">
            {children}
          </div>
        </main>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}

export default PlantillaDetalle;